<div class="explorer-toolbar">
  <!-- Search input -->
  <div class="explorer-toolbar__search">
    <input
      type="search"
      class="explorer-toolbar__search-input"
      placeholder="Search assets..."
      [value]="searchValue()"
      (input)="onSearchChange($any($event.target).value)"
      [disabled]="isLoading()"
    />
  </div>

  <!-- View mode toggle -->
  <div class="explorer-toolbar__view-toggle">
    <button
      tds-button
      variant="secondary"
      size="md"
      [class.active]="isViewModeActive(ViewMode.INSTANCE)"
      (click)="onViewModeChange(ViewMode.INSTANCE)"
      [disabled]="isLoading()"
    >
      Assets
    </button>
    <button
      tds-button
      variant="secondary"
      size="md"
      [class.active]="isViewModeActive(ViewMode.TYPE)"
      (click)="onViewModeChange(ViewMode.TYPE)"
      [disabled]="isLoading()"
    >
      Types
    </button>
  </div>

  <!-- Action buttons -->
  <div class="explorer-toolbar__actions">
    <button
      tds-icon-button
      label="Expand all"
      [disabled]="isLoading()"
      (click)="onExpandAll()"
    >
      <tds-icon name="menu"></tds-icon>
    </button>

    <button
      tds-icon-button
      label="Collapse all"
      [disabled]="isLoading()"
      (click)="onCollapseAll()"
    >
      <tds-icon name="list"></tds-icon>
    </button>

    <button
      tds-icon-button
      label="Refresh assets"
      [disabled]="isLoading()"
      (click)="onRefresh()"
    >
      <tds-icon name="refresh"></tds-icon>
    </button>
  </div>
</div>
